<template>
  <div class="cancel-card">
    <div class="info">
      <page-info
        :title="`Уверены, что хотите отменить заказ №&nbsp;${orderNumber}`"
        subtitle="Пожалуйста, укажите причину отмены:"
      />
    </div>

    <radio-group
      v-model="code"
      :options="reasons"
      name="reasons"
    />

    <transition name="fade">
      <ui-textarea
        v-if="otherReason"
        v-model="comment"
        class="comment"
        placeholder="Укажите причину отмены заказа"
        height="60"
      />
    </transition>

    <div class="buttons">
      <ui-button
        wide
        :disabled="!code || (otherReason && !comment)"
        :loading="progress"
        text="Отменить заказ"
        @click="cancelOrder"
      />

      <ui-button
        wide
        secondary
        text="Не отменять"
        @click="$emit('on-close')"
      />
    </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex';
import PageInfo from '../common/page-info';

export default {
  name: 'cancel-card',

  components: {
    PageInfo
  },

  props: {
    reasons: {
      type: Array,
      default: () => [],
    },

    orderNumber: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      code: '',
      comment: '',
      progress: false
    }
  },

  computed: {
    otherReason() { // Другая причина
      return this.code === '132';
    },

    computedOrderNumber() {
      return this.orderNumber.indexOf('/') !== -1
          ? this.orderNumber.replace('/', '%2F')
          : this.orderNumber;
    }
  },

  methods: {
    ...mapActions({
      LOAD_ORDERS: 'orders/loadOrders'
    }),

    cancelOrder() {
      this.progress = true;
      this.$store.$api.cancelOrder({
        orderNumber: this.computedOrderNumber,
        form: {
          cancelReasonCode: this.code,
          comment: this.otherReason ? this.comment : '' // 132 - Другая причина
        }})
          .then(() => {
            this.$emit('on-order-update'); // обновляем карточку заказа

            this.progress = false;
            this.$emit('on-close');
            this.$store.dispatch('notifications/create', {
              title: 'Успешно!',
              message: 'Ваш заказ отменен',
              type: 'success'
            });
          })
          .catch(() => {
            this.$store.dispatch('notifications/create', {
              title: 'Ошибка',
              message: 'Не удалось отменить заказ. Повторите запрос позже.',
            });
          })
    },
  }
};
</script>

<style lang="scss">
.cancel-card {
  .info .page-info {
    margin-top: 0;

    .description {
      padding: 4px 8px;
    }
  }

  .comment,
  .buttons {
    margin-top: 20px;
  }

  .comment {
    .ui-textarea-container {
      padding: 0 6px;
    }
  }

  .buttons {
    & > button:last-of-type {
      margin-top: 10px;
    }
  }

  & > .ui-loader {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: $blue;
  }
}

@include breakpoint("tablet") {
  .cancel-card {
    max-width: 392px;

    .comment {
      padding: 0 24px;
    }

    .buttons {
      display: flex;
      flex-direction: row-reverse;
      justify-content: center;

      & > button {
        width: auto;
      }

      & > button:last-of-type {
        margin-top: 0;
        margin-right: 16px;
      }
    }
  }
}
</style>